export class Constants {
  static readonly DATE_FMT = 'dd/MMM/yyyy';
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;
  static readonly DATE_SPECIAL_FMT = 'MM/dd/yy';
  static readonly DATE_MM_DD_YYYY = 'MM/dd/yyyy';
  static readonly COLLISION_LOSS = 'Collision Loss Settlement (ACV, Stated)';
  static readonly LIMITTED_COLLISION_LOSS =
    'Limited Collision Loss Settlement (ACV, Stated)';
  static readonly COMPREHENSIVE_LOSS =
    'Comprehensive Settlement (ACV, Stated, Agreed)';
  static readonly FORM_CONTROL = 'form-control';
  static readonly LEARN_MORE = 'Learn more';
  static readonly PER_PERSON_ACCIDENT = '(per person/accident)';
  static readonly COLLISION_COVERAGE_URL = 'https://www.mapfreinsurance.com/blog/collision-coverage/';
  static readonly DISPLAY_NONE = 'display: none';
  static readonly ENROLLED = 'ENROLLED';
  static readonly UNENROLLED = 'UNENROLLED';
  static readonly ENROLLMENT_PENDING = 'ENROLLMENT-PENDING';
  static readonly CANCILLATION_REASON_NON_PAYMENT = 'pay - non-payment of insurance premium';
  static readonly CANCILLATION_REASON_FPD_FAILURE = 'fpd - failure to pay deposit';
  static readonly EDIT_ENROLL = 'edit-enroll';
  static readonly HIDE_AMOUNT_CLASS = 'hide-balance';
  static readonly ROTATE_TRIANGLE_CLASS = 'rotate-triangle';
  static readonly EXPANDED_ARROW_CLASS = 'fa-chevron-up';
  static readonly COLLAPSED_ARROW_CLASS = 'fa-chevron-down';

  static readonly PAYMENT_CONFIRMATION = 'payment-confirmation';
  static readonly MAKE_PAYMENT = 'make-payment';
  static readonly BILLING_PAPERLESS = '/billing/paperless';
  static readonly BILLING_PAPERLESS_END_WITH_SLASH = '/billing/paperless/';
  static readonly MY_INSURANCE = '/my-insurance';
  static readonly HOME_PAGE = '/home';
  static readonly MY_INSURANCE_LINK_POLICY = '/my-insurance/link-policy';
  static readonly MAKE_PAYMENT_ROUTE ='/make-payment';
  
  static readonly BODILY_INJURY_TO_OTHERS_DESC = `If you injure someone in an accident that is your fault, then Bodily Injury, sometimes called BI, will pay for an injured person's qualifying medical bills and other compensable harm, up to your policy limits.`;

  static readonly ENROLL_FAILED = 'GUEST_PAPERLESS_ERROR: ENROLL_FAILED';
  static readonly DATA_MISMATCHED = 'GUEST_PAPERLESS_ERROR: DATA_MISMATCHED';
  static readonly ENROLLED_ALREADY = 'GUEST_PAPERLESS_ERROR: ENROLLED_ALREADY';
  static readonly POLICY_NOT_LOCATED = 'GUEST_PAPERLESS_ERROR: POLICY_NOT_LOCATED';
  // static readonly AAA_MEMBERSHIP_REQUEST = 'AAA Discount Validation';
  static readonly REFUNDS_TOPIC = 'Refunds';
  static readonly DISCOUNT_TOPIC = 'Discounts';
  static readonly CANCELLATION_TOPIC = 'Cancellations';
  static readonly EASY_REPAIRES_LEARN_MORE_LINK = 'https://www.mapfreinsurance.com/car-insurance/car-ez/';
  static readonly STRESS_FREE_CLAMS_LEARN_MORE_LINK = 'https://www.mapfreinsurance.com/property-insurance/home-repair-program/';
}
